import React,{useEffect} from 'react'
import Topnavbar from '../layout/header/Topnavbar'
import Footer from '../layout/footer/Footer'
import Main from '../layout/main/Main'
import AOS from "aos";
import "aos/dist/aos.css";

const Home = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);
  return (
    <div>
      <Topnavbar/>
      <Main/>
     <Footer/>     
    </div>
  )
}
export default Home
